import './header.scss';

// Desktop dropdowns are handled purely with CSS :hover. JavaScript only drives
// the mobile drawer: the hamburger toggle and per-item accordion expansion.

const header = document.getElementById('masthead');
const toggle = document.getElementById('menuToggle');

// Must match the CSS `media(max, desktop)` breakpoint (see _variables.scss):
// the drawer/accordion is active only while the hamburger is shown (<= 1199px).
const isMobile = () => window.matchMedia('(max-width: 1199px)').matches;

if (header && toggle) {
	toggle.addEventListener('click', () => {
		const isOpen = header.classList.toggle('header--open');
		toggle.setAttribute('aria-expanded', String(isOpen));
	});
}

const dropdownItems = document.querySelectorAll<HTMLElement>(
	'.header__nav-item--has-dropdown'
);

dropdownItems.forEach((item) => {
	const link = item.querySelector<HTMLAnchorElement>('.header__nav-link');
	if (!link) return;

	link.addEventListener('click', (event) => {
		// Only intercept on mobile; on desktop the link/hover behaves normally.
		if (!isMobile()) return;
		event.preventDefault();
		const isOpen = item.classList.toggle('header__nav-item--open');
		link.setAttribute('aria-expanded', String(isOpen));
	});
});

// Reset any mobile-open state when resizing up to desktop.
window.addEventListener('resize', () => {
	if (!isMobile()) {
		header?.classList.remove('header--open');
		toggle?.setAttribute('aria-expanded', 'false');
		dropdownItems.forEach((item) =>
			item.classList.remove('header__nav-item--open')
		);
	}
});
